import {StyledInfoDescription, StyledInfoTitle, StyledInfoWrapper} from '@/features/measures/components/info/style.ts'
import {Chip} from '@components/ui/chip/Chip.tsx'
import {FC, ReactNode} from 'react'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {toast} from 'react-hot-toast'
import {copyToClipboard} from '@/utilities/helpers'
import {useTranslation} from 'react-i18next'

type InfoProps = {
    icon?: ReactNode
    title: string
    description: string | ReactNode
    canCopy?: boolean
    copyText?: string
}

export const Info: FC<InfoProps> = ({icon, title, description, canCopy = false, copyText}) => {
    const {t} = useTranslation()

    const handleCopy = () => {
        if (canCopy) {
            const textToCopy = copyText ?? description?.toString()
            if (textToCopy) {
                copyToClipboard(textToCopy)
                toast.success(t('commons:copy_success'))
            } else {
                toast.error(t('commons:copy_failed'))
            }
        }
    }

    return (
        <StyledInfoWrapper>
            <Chip icon={icon} doubleCircle />
            <Flexbox direction={'column'} gap={2}>
                <StyledInfoTitle>{title}</StyledInfoTitle>
                <StyledInfoDescription
                    onClick={handleCopy}
                    style={{
                        cursor: canCopy ? 'pointer' : 'default'
                    }}
                    onMouseEnter={e => canCopy && (e.currentTarget.style.opacity = '0.7')}
                    onMouseLeave={e => canCopy && (e.currentTarget.style.opacity = '1')}
                >
                    {description}
                </StyledInfoDescription>
            </Flexbox>
        </StyledInfoWrapper>
    )
}
